import React from 'react'
import { StyledIcon } from '../StyledIcon'
import { GeneralIconPropsType } from './types'

 const EyeVisibleOnIcon = ({ icon, size,color="black", customProps }: GeneralIconPropsType) => (
  <StyledIcon
    viewBox="0 0 24 24" 
    a11yTitle={icon}
    color={color}
    size={size}
    {...customProps}
    width="24"
    height="24"  
  >
    <path d="M12 5.4375C7.625 5.4375 3.88875 8.15875 2.375 12C3.88875 15.8412 7.625 18.5625 12 18.5625C16.375 18.5625 20.1112 15.8412 21.625 12C20.1112 8.15875 16.375 5.4375 12 5.4375ZM12 16.375C9.585 16.375 7.625 14.415 7.625 12C7.625 9.585 9.585 7.625 12 7.625C14.415 7.625 16.375 9.585 16.375 12C16.375 14.415 14.415 16.375 12 16.375ZM12 9.375C10.5475 9.375 9.375 10.5475 9.375 12C9.375 13.4525 10.5475 14.625 12 14.625C13.4525 14.625 14.625 13.4525 14.625 12C14.625 10.5475 13.4525 9.375 12 9.375Z" fill="#3E3E47"/>
  </StyledIcon>
)

export const svgPath = "M12 5.4375C7.625 5.4375 3.88875 8.15875 2.375 12C3.88875 15.8412 7.625 18.5625 12 18.5625C16.375 18.5625 20.1112 15.8412 21.625 12C20.1112 8.15875 16.375 5.4375 12 5.4375ZM12 16.375C9.585 16.375 7.625 14.415 7.625 12C7.625 9.585 9.585 7.625 12 7.625C14.415 7.625 16.375 9.585 16.375 12C16.375 14.415 14.415 16.375 12 16.375ZM12 9.375C10.5475 9.375 9.375 10.5475 9.375 12C9.375 13.4525 10.5475 14.625 12 14.625C13.4525 14.625 14.625 13.4525 14.625 12C14.625 10.5475 13.4525 9.375 12 9.375Z";

export default EyeVisibleOnIcon